const regions = [
	{
		name: '서울특별시',
		children: [
			'종로구',
			'중구',
			'용산구',
			'성동구',
			'광진구',
			'동대문구',
			'중랑구',
			'성북구',
			'강북구',
			'도봉구',
			'노원구',
			'은평구',
			'서대문구',
			'마포구',
			'양천구',
			'강서구',
			'구로구',
			'금천구',
			'영등포구',
			'동작구',
			'관악구',
			'서초구',
			'강남구',
			'송파구',
			'강동구',
		],
	},
	{
		name: '부산광역시',
		children: [
			'중구',
			'서구',
			'동구',
			'영도구',
			'부산진구',
			'동래구',
			'남구',
			'북구',
			'해운대구',
			'사하구',
			'금정구',
			'강서구',
			'연제구',
			'수영구',
			'사상구',
			'기장군',
		],
	},
	{
		name: '대구광역시',
		children: [
			'중구',
			'동구',
			'서구',
			'남구',
			'북구',
			'수성구',
			'달서구',
			'달성군',
		],
	},
	{
		name: '인천광역시',
		children: [
			'중구',
			'동구',
			'미추홀구',
			'연수구',
			'남동구',
			'부평구',
			'계양구',
			'서구',
			'강화군',
			'옹진군',
		],
	},
	{
		name: '광주광역시',
		children: ['동구', '서구', '남구', '북구', '광산구'],
	},
	{
		name: '대전광역시',
		children: ['동구', '중구', '서구', '유성구', '대덕구'],
	},
	{
		name: '울산광역시',
		children: ['중구', '남구', '동구', '북구', '울주군'],
	},
	{
		name: '세종특별자치시',
		children: ['세종시'],
	},
	{
		name: '경기도',
		children: [
			'수원시',
			'성남시',
			'의정부시',
			'안양시',
			'부천시',
			'광명시',
			'평택시',
			'동두천시',
			'안산시',
			'고양시',
			'과천시',
			'구리시',
			'남양주시',
			'오산시',
			'시흥시',
			'군포시',
			'의왕시',
			'하남시',
			'용인시',
			'파주시',
			'이천시',
			'안성시',
			'김포시',
			'화성시',
			'광주시',
			'양주시',
			'포천시',
			'여주시',
		],
	},
	{
		name: '강원특별자치도',
		children: [
			'춘천시',
			'원주시',
			'강릉시',
			'동해시',
			'속초시',
			'삼척시',
			'태백시',
		],
	},
	{
		name: '충청북도',
		children: ['청주시', '충주시', '제천시'],
	},
	{
		name: '충청남도',
		children: [
			'천안시',
			'공주시',
			'보령시',
			'아산시',
			'서산시',
			'논산시',
			'계룡시',
			'당진시',
		],
	},
	{
		name: '전북특별자치도',
		children: ['전주시', '군산시', '익산시', '정읍시', '남원시', '김제시'],
	},
	{
		name: '전라남도',
		children: ['목포시', '여수시', '순천시', '나주시', '광양시'],
	},
	{
		name: '경상북도',
		children: [
			'포항시',
			'경주시',
			'김천시',
			'안동시',
			'구미시',
			'영주시',
			'영천시',
			'상주시',
			'문경시',
			'경산시',
		],
	},
	{
		name: '경상남도',
		children: [
			'창원시',
			'진주시',
			'통영시',
			'사천시',
			'김해시',
			'밀양시',
			'거제시',
			'양산시',
		],
	},
	{
		name: '제주특별자치도',
		children: ['제주시', '서귀포시'],
	},
];

export default regions;
